import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=506b0ee8&scoped=true&"
import script from "./ListUsers.vue?vue&type=script&lang=js&"
export * from "./ListUsers.vue?vue&type=script&lang=js&"
import style0 from "./ListUsers.vue?vue&type=style&index=0&id=506b0ee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b0ee8",
  null
  
)

export default component.exports